import { Link } from "react-router-dom";
import { categories } from "@/mocks/cases";
import { siteInfo } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="px-4 md:px-8 pt-12 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <span className="flex w-10 h-10 items-center justify-center rounded-md bg-accent-500 text-primary-950 font-heading text-xl font-bold">
                瓜
              </span>
              <span className="font-heading text-lg font-bold">{siteInfo.name}</span>
            </div>
            <p className="text-sm leading-relaxed text-background-100/75">{siteInfo.intro}</p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4 text-accent-300">站内导航</h4>
            <ul className="flex flex-col gap-2.5 text-sm">
              <li>
                <Link to="/" className="text-background-100/75 hover:text-accent-300 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/archive"
                  className="text-background-100/75 hover:text-accent-300 transition-colors cursor-pointer"
                >
                  爆料档案库
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-background-100/75 hover:text-accent-300 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/#faq"
                  className="text-background-100/75 hover:text-accent-300 transition-colors cursor-pointer"
                >
                  常见问题
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4 text-accent-300">档案分类</h4>
            <ul className="flex flex-col gap-2.5 text-sm">
              {categories
                .filter((c) => c.id !== "all")
                .map((c) => (
                  <li key={c.id}>
                    <Link
                      to={`/archive?cat=${c.id}`}
                      className="text-background-100/75 hover:text-accent-300 transition-colors cursor-pointer"
                    >
                      {c.name}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4 text-accent-300">联系与投递</h4>
            <ul className="flex flex-col gap-2.5 text-sm text-background-100/75">
              <li className="flex items-center gap-2">
                <i className="ri-mail-send-line text-accent-300" />
                <a
                  href={`mailto:${siteInfo.tipsEmail}`}
                  className="hover:text-accent-300 transition-colors cursor-pointer"
                >
                  {siteInfo.tipsEmail}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-accent-300" />
                <a
                  href={`mailto:${siteInfo.email}`}
                  className="hover:text-accent-300 transition-colors cursor-pointer"
                >
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2 leading-relaxed">
                <i className="ri-shield-check-line text-accent-300 mt-1" />
                <span>线索投递默认匿名处理，仅用于材料核对。</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-100/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-background-100/60">
          <p>© {year} {siteInfo.fullName}</p>
          <p className="leading-relaxed">内容为公开材料整理与读者讨论，不构成任何事实认定，请理性围观。</p>
        </div>
      </div>
    </footer>
  );
}